import { uniqueId } from 'js/utils/methods.util';

export const camelCaseToSpaces = word => word.replace(/([A-Z])/g, $1 => ` ${$1.toLowerCase()}`);

export const spacesToCamelCase = word => word.replace(/(\s[a-z])/g, $1 => $1.toUpperCase().trim());

export const prepareOptions = options => Object.keys(options).reduce((memo, key) => (
    { ...memo, [camelCaseToSpaces(key)]: options[key] }), {}
);

export const parseMessage = (message) => {
    try {
        return typeof message === 'string' ? JSON.parse(message) : message;
    } catch (error) {
        return null;
    }
};

export const updateCorrelationId = (request) => {
    let updatedRequest = request;
    if (!updatedRequest.correlationId) {
        updatedRequest = {
            ...updatedRequest,
            correlationId: uniqueId('correlationId_')
        };
    }

    if (updatedRequest.requests) {
        updatedRequest = {
            ...updatedRequest,
            requests: updatedRequest.requests.map(req => ({
                ...req,
                correlationId: updatedRequest.correlationId
            }))
        };
    }

    return updatedRequest;
};

export const addRelativeUri = (request) => {
    const { pathname, search } = window.location;

    return {
        ...request,
        relativeURI: `${pathname}${search}`
    };
};
